export const key = (state) => state.edFormData.key;